const gtmTracking = ({ name }) => {
  if (!window.dataLayer) return;
  window.dataLayer.push({ event: name });
};

export default gtmTracking;
